import styled from 'styled-components'
import { OptionButton } from '../buttons/OptionButton'
import { theme } from '../../theme/theme'

type BooleanInputProps = {
  options: { id: string; text: string }[]
  answer: string[]
  setAnswer: (option: string[]) => void
  color?: string
  backgroundColor?: string
}

export const BooleanInput = ({ options, color, backgroundColor, answer, setAnswer }: BooleanInputProps) => {
  return (
    <BooleanContainer>
      {options.map((option, index) => (
        <OptionButton
          key={index}
          onClick={() => setAnswer([option.id])}
          option={option.text}
          type="boolean"
          backgroundColor={backgroundColor}
          color={color}
          selected={Boolean(answer[0]) && answer[0] === option.id}
        />
      ))}
    </BooleanContainer>
  )
}

const BooleanContainer = styled.div`
  display: flex;
  gap: ${theme.spacing.xsmall}px;
`
